class PaginationChange extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      nextTrigger: this.querySelector('[data-pagination-change-el="next-trigger"]'),
      prevTrigger: this.querySelector('[data-pagination-change-el="prev-trigger"]')
    }

    // Store bound handlers for cleanup
    this._boundHandlers = {
      handleProductsUpdated: (products) => {
        if(products.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden');
        }
      },
      handleNextClick: () => {
        window.theme.tagalys.results.eventBus.publish('results:ui:pagination:changed', {
          direction: 'next'
        });
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      },
      handlePrevClick: () => {
        window.theme.tagalys.results.eventBus.publish('results:ui:pagination:changed', {
          direction: 'previous'
        });
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      },
    }
  }

  connectedCallback() {
    this.subscribeToEvents();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    this.unsubscribeFromEvents();
    this.detachEventListeners();
  }

  subscribeToEvents() {
    window.theme.tagalys.results.eventBus.subscribe('results:state:products:updated', this._boundHandlers.handleProductsUpdated)
  }

  unsubscribeFromEvents() {
    window.theme.tagalys.results.eventBus.unsubscribe('results:state:products:updated', this._boundHandlers.handleProductsUpdated)
  }

  attachEventListeners() {
    this.elements.nextTrigger.addEventListener('click', this._boundHandlers.handleNextClick);
    this.elements.prevTrigger.addEventListener('click', this._boundHandlers.handlePrevClick);
  }

  detachEventListeners() {
    this.elements.nextTrigger.removeEventListener('click', this._boundHandlers.handleNextClick);
    this.elements.prevTrigger.removeEventListener('click', this._boundHandlers.handlePrevClick);
  }

  render() {
    const hasNextPage = window.theme.tagalys.results.SDK.helpers.hasNextPage()
    const hasPreviousPage = window.theme.tagalys.results.SDK.helpers.hasPreviousPage()

    if (hasNextPage) {
      this.elements.nextTrigger.classList.remove('hidden');
    } else {
      this.elements.nextTrigger.classList.add('hidden');
    }

    if (hasPreviousPage) {
      this.elements.prevTrigger.classList.remove('hidden');
    } else {
      this.elements.prevTrigger.classList.add('hidden');
    }
  }

}

customElements.define('pagination-change', PaginationChange);
